import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { DriverShell } from "@/components/shells";
import { Panel, Spinner, Btn, Field, Textarea } from "@/components/kit";
import { useAsync } from "@/lib/hooks";
import { loadDriverContext } from "@/lib/driverData";
import { supabase } from "@/lib/supabase";

const TYPES = [
  { value: "not_assigned", label: "This vehicle is no longer assigned to me" },
  { value: "registration_incorrect", label: "The registration is incorrect" },
  { value: "driver_details_incorrect", label: "My driver details are incorrect" },
  { value: "other", label: "Other allocation issue" },
];

export default function DriverAllocationIssue() {
  const nav = useNavigate();
  const { data: ctx, loading } = useAsync(() => loadDriverContext(), []);
  const [type, setType] = useState("not_assigned");
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  if (loading) return <DriverShell back="/driver/vehicle"><Spinner /></DriverShell>;

  const submit = async () => {
    setSaving(true);
    try {
      const { error } = await supabase.from("allocation_exceptions").insert({
        customer_id: ctx.driver.customer_id,
        vehicle_id: ctx.vehicle?.id || null,
        driver_id: ctx.driver.id,
        allocation_id: ctx.allocation?.id || null,
        exception_type: type,
        driver_message: message || null,
        status: "open",
      });
      if (error) throw error;
      toast.success("Reported. Your Venson team will review this — your allocation is unchanged for now.");
      nav("/driver", { replace: true });
    } catch (err) {
      toast.error(err.message || "Could not submit your report.");
    } finally { setSaving(false); }
  };

  return (
    <DriverShell back="/driver/vehicle" title="Report incorrect allocation">
      <Panel className="p-3 mb-4 text-sm text-muted-foreground">
        This raises a review with your Venson team. It does not change your allocation directly.
      </Panel>
      <div className="space-y-2" data-testid="allocation-issue-options">
        {TYPES.map((t) => (
          <button key={t.value} data-testid={`alloc-issue-${t.value}`} onClick={() => setType(t.value)}
            className={`w-full text-left p-4 rounded-[3px] border text-sm ${type === t.value ? "border-primary bg-primary/10 text-primary" : "border-[hsl(var(--input))]"}`}>
            {t.label}
          </button>
        ))}
      </div>
      <div className="mt-4">
        <Field label="Anything else we should know?">
          <Textarea data-testid="alloc-issue-message" rows={3} value={message} onChange={(e) => setMessage(e.target.value)} />
        </Field>
      </div>
      <Btn onClick={submit} loading={saving} data-testid="alloc-issue-submit" className="w-full mt-4">Submit report</Btn>
    </DriverShell>
  );
}
